// @flow

import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { Logo } from '../logos/Logo'
import * as text from '../text'

type JobType = {
  title: string,
  description: string,
  team: 'track' | 'hire' | 'plan',
  slug: string,
  ...
}

type Props = {
  title: string,
  jobs: $ReadOnlyArray<JobType>,
}
export const ThreeCol = ({ title, jobs }: Props) => {
  const count = jobs.length
  const summaryText = `${count} position${count === 1 ? '' : 's'}`

  return (
    <Root>
      <HeaderWrapper>
        <Summary>{summaryText}</Summary>
        <text.H3 color={colors.yellow}>{title}</text.H3>
      </HeaderWrapper>

      {jobs.map((vacancy, id) => (
        <VacancyWrapper to={`/jobs/${vacancy.slug}/`} key={id}>
          <VacancyTitleWrapper> {vacancy.title}</VacancyTitleWrapper>

          <VacancyDescription>{vacancy.description}</VacancyDescription>

          <TeamStyled>
            <Logo kind={vacancy.team} />
          </TeamStyled>
        </VacancyWrapper>
      ))}
    </Root>
  )
}

const TeamStyled: React.ComponentType<any> = styled.div`
  svg {
    height: 28px;
  }
  ${media.mq[2]} {
    flex: 0 0 160px;
    text-align: right;
  }
`

const VacancyDescription: React.ComponentType<any> = styled(text.P3)`
  display: none;
  ${media.mq[1]} {
    display: block;
    flex: 2.5;
    padding-right: 30px;
  }
`

const VacancyTitleWrapper: React.ComponentType<any> = styled(text.P1)`
  ${media.mq[2]} {
    flex: 1;
    padding-right: 30px;
  }
`

const VacancyWrapper: React.ComponentType<any> = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 30px;
  margin: 10px 0;
  background: ${colors.darkPurple};
  color: ${colors.beige};
  ${media.mq[1]} {
    margin: 15px 0;
    &:hover {
      background-color: ${colors.fadedPurpleAlt};
    }
  }
  ${media.mq[2]} {
    flex-direction: row;
    justify-content: space-between;
    padding: 45px;
  }
`

const HeaderWrapper: React.ComponentType<any> = styled.div`
  margin: 0 0 25px;
`

const Summary: React.ComponentType<any> = styled(text.P1)`
  color: ${colors.beige};
  margin-bottom: 6px;
  ${media.mq[1]} {
    margin-bottom: 0;
  }
`

const Root: React.ComponentType<any> = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 20px;
  ${media.mq[1]} {
    margin-bottom: 40px;
  }
`
